import { useRef, useEffect } from 'react';
import { useWindowSize } from 'helpers/useWindowSize.ts';

export type UseModalExternalButtonProps = {
  offsetRight: number;
  offsetTop: number;
  isOpen: boolean;
};

export const useModalExternalButton = (props: UseModalExternalButtonProps) => {
  const anchorRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);

  const realignButton = () => {
    if (buttonRef.current) {
      buttonRef.current.style.right = `${(anchorRef.current?.offsetLeft ?? 0) + props.offsetRight}px`;
      buttonRef.current.style.top = `${(anchorRef.current?.offsetTop ?? 0) + props.offsetTop}px`;
    }
  };

  const windowSize = useWindowSize();

  useEffect(() => {
    setTimeout(() => {
      realignButton();
    });
  }, [windowSize, buttonRef.current, anchorRef.current, props.isOpen]);

  const anchor = <div ref={anchorRef} />;

  return { anchor, buttonRef };
};
